import script from "./AppOptionsComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppOptionsComponent.vue?vue&type=script&setup=true&lang=ts"

import "./AppOptionsComponent.vue?vue&type=style&index=0&id=361ea2e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-361ea2e0"]])

export default __exports__